// angular libs
import { Routes } from '@angular/router';

// marketplace libs
import { AuthenticationLoginComponent } from './components/login/login.component';
import { AuthenticationLogoutComponent } from './components/logout/logout.component';
import { AuthenticationTokenComponent } from './components/token/token.component';
import { AuthenticationExchangeComponent } from './components/exchange/exchange.component';
import { AuthenticationErrorComponent } from './components/error/authentication-error.component';

export const AuthenticationRoutes: Routes = [
  {
    path: 'login',
    component: AuthenticationLoginComponent,
  },
  {
    path: 'token',
    component: AuthenticationTokenComponent,
  },
  {
    path: 'logout',
    component: AuthenticationLogoutComponent,
  },
  {
    path: 'exchange',
    component: AuthenticationExchangeComponent,
  },
  {
    path: '401',
    component: AuthenticationErrorComponent,
    data: { error: 401 },
  },
  {
    path: '412',
    component: AuthenticationErrorComponent,
    data: { error: 412 },
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
];
